import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const UserCircleIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>User Circle Icon</title>;
    t1 = <circle cx="12" cy="9" r="3" stroke="currentColor" strokeWidth="1.5" />;
    t2 = <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />;
    t3 = <path d="M17.9691 20C17.81 17.1085 16.9247 15 11.9999 15C7.07521 15 6.18991 17.1085 6.03076 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props) {
    t4 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}</svg>;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};